import { useEffect, useState } from "react";
import { resolveStorageDisplayUrl } from "@/lib/resolveStorageDisplayUrl";

/** Resolve storage URLs to signed URLs for authenticated display. */
export function useResolvedStorageUrls(urls: string[]): string[] {
  const key = urls.join("\0");
  const [resolved, setResolved] = useState<string[]>(urls);

  useEffect(() => {
    let cancelled = false;
    const list = key ? key.split("\0") : [];
    void (async () => {
      if (list.length === 0) {
        if (!cancelled) setResolved([]);
        return;
      }
      const next = await Promise.all(list.map((u) => resolveStorageDisplayUrl(u)));
      if (!cancelled) setResolved(next);
    })();
    return () => {
      cancelled = true;
    };
  }, [key]);

  return resolved.length === urls.length ? resolved : urls;
}
